import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import {FileManagerModule} from "./file-manager/file-manager.module";

import { FuseSharedModule } from "@fuse/shared.module";
import { ChatModule } from "./chat/chat.module";
import { MatChipsModule } from "@angular/material/chips";

const routes = [   
    {
        path: "chat",
        loadChildren: () => import("./chat/chat.module").then(m => m.ChatModule)
    },
    {
        path: "calendar",
        loadChildren: () => import("./calendar/calendar.module").then(m => m.CalendarModule)
    },    
    {
        path: "file-manager",
        loadChildren: () => import("./file-manager/file-manager.module").then(m => m.FileManagerModule)
    }    
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        FuseSharedModule,
        FileManagerModule,
        ChatModule,
        MatChipsModule
    ],
})
export class AppsModule { }
